import Card from 'react-bootstrap/Card'
import styled from 'styled-components'

const CardWrapper = styled(Card)`
  box-shadow: 0 1px 10px 0 ${({ theme }) => theme.card.border};
`

export default CardWrapper
